import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { PrimaryButton } from '../../components/common/buttons/PrimaryButton';
import PlusIcon from '../../components/icons/PlusIcon';
import TitleWrapper from '../../components/wrappers/titleWrapper/TitleWrapper';
import { routes } from '../../static/routes';
import PartnersList from './components/PartnersList';

const PartnersView = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <TitleWrapper title={t('partners.title')}>
      <div className="flex mb-8 justify-end items-end">
        <PrimaryButton
          onClick={() => navigate(routes.addPartner)}
          className="w-fit self-end"
          prefixIcon={<PlusIcon size={16} />}
        >
          {t('partners.addButton')}
        </PrimaryButton>
      </div>
      <PartnersList />
    </TitleWrapper>
  );
};

export default PartnersView;
